<template>
    <div class="webstated">
        <div class="content">
            <h1>{{$t('nav.w34')}}</h1>
            <div class="text" v-html="$t('other.w37')"></div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="less" scoped>
.webstated {
    height: 740px;
   .content{
       width: 800px;
       color: #232325;
       margin: 0 auto;
       h1{
           text-align: center;
           margin: 50px 0;
       }
       .text{
           font-size: 14px;
           /deep/ .p1{
               margin-bottom: 30px;
           }
           /deep/ .p2{
               text-align: right;
           }
           /deep/ .p3{
               padding-left: 5px;
               margin-bottom: 5px;
               display: flex;
               span{
                   display: block;
               }
           }
           /deep/ .p4{
               margin: 30px 0 20px 0;
           }
       }
   } 
}
</style>
    